import React from 'react';
import {
    Box,
    Button,
    Grid,
    Typography
} from '@mui/material';
import {
    ArrowBack as ArrowBackIcon,
    Add as AddIcon,
    Edit as EditIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { FONT_FAMILY_DISPLAY } from '../../theme';

type PropsType = {
    title: string,
    subtitle?: string,
    hideBackButton?: boolean,
    addButton?: {
        url: string,
        label?: 'Skapa nytt' | 'Skapa nytt'
    } | null,
    editUrl?: string | null,
    CustomComponent?: JSX.Element | null,
    titleIcon?: { icon: JSX.Element, top?: string } | null,
    subtitleIcon?: { icon: JSX.Element, top?: string } | null,
};

const Header: React.FC<PropsType> = (props) => {
    const {
        title,
        subtitle,
        addButton,
        editUrl,
        hideBackButton = false,
        CustomComponent,
        titleIcon,
        subtitleIcon
    } = props;

    const navigate = useNavigate();

    return (
        <Grid container spacing={1} sx={{ pb: 2 }} alignItems="flex-end">
            <Grid item xs>
                <Typography
                    variant="h4"
                    noWrap
                    gutterBottom={!subtitle}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontFamily: FONT_FAMILY_DISPLAY,
                        fontWeight: 600,
                        letterSpacing: '-0.02em'
                    }}
                >
                    {title}
                    {titleIcon && (
                        <Box
                            component="span"
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                ml: 0.5,
                                position: 'relative',
                                top: titleIcon.top || '0px',
                                '& .MuiSvgIcon-root': {
                                    fontSize: '1em'
                                }
                            }}
                        >
                            {titleIcon.icon}
                        </Box>
                    )}
                </Typography>
                {subtitle && (
                    <Typography variant="h6" noWrap>
                        {subtitle}
                        {subtitleIcon && (
                            <Box
                                component="span"
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    ml: 0.75,
                                    position: 'relative',
                                    top: subtitleIcon.top || '0px',
                                    '& .MuiSvgIcon-root': {
                                        fontSize: '1em'
                                    }
                                }}
                            >
                                {subtitleIcon.icon}
                            </Box>
                        )}
                    </Typography>
                )}
            </Grid>
            {!hideBackButton && (
                <Grid item>
                    <Button variant="text" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
                        Tillbaka
                    </Button>
                </Grid>
            )}
            {CustomComponent && (
                <Grid item>
                    {CustomComponent}
                </Grid>
            )}
            {editUrl && (
                <Grid item>
                    <Button variant="outlined" startIcon={<EditIcon />} onClick={() => navigate(editUrl)}>
                        Redigera
                    </Button>
                </Grid>
            )}
            {addButton && (
                <Grid item>
                    <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate(addButton.url)}>
                        {addButton.label || 'Skapa ny'}
                    </Button>
                </Grid>
            )}
        </Grid>
    );
};

export default Header;
